export default "__VITE_ASSET__Pxt11fpC__"